export * from './identification-type-api.service';
export * from './identification-type-api.interface';
